export default __webpack_public_path__ + "a5b7734d099641c7be63a994d1800721.webp";